import type { OperationVariables, QueryHookOptions, QueryResult, TypedDocumentNode } from '@apollo/client';
import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { loggedInAsAdvisorID } from '@savvy/deprecated-shared/utils/savvy-auth';

import { logGraphqlError } from './logGraphqlError';

function isAuthorizationError(errorMessage: string) {
  return errorMessage.includes("QueryType's authorization check");
}

export function useQueryWithErrorLogging<TVariables extends OperationVariables, TData>(
  query: TypedDocumentNode<TData, TVariables>,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> {
  const resp = useQuery(query, options);
  const advisorId = loggedInAsAdvisorID();
  const { user: authUser, reauth } = useAuth();

  useEffect(() => {
    if (resp.error) {
      logGraphqlError(query, resp.error, { userId: authUser?.id, advisorId });
      if (isAuthorizationError(resp.error.message)) {
        reauth();
      }
    }
  }, [resp.error]);

  return resp;
}
